import type {
  UserProfileUpdatePayload,
  UserProfileUpdateVariables,
} from "./current-user-profile.type";
import type { ApiError } from "@/services/api";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { client } from "@/config/client";

import { CURRENT_USER_PROFILE_QUERY_KEY } from "./current-user-profile.constant";

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();

  const mutationFn = (data: UserProfileUpdateVariables) => {
    return client.profile.update(data);
  };

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: CURRENT_USER_PROFILE_QUERY_KEY });
  };

  return useMutation<
    UserProfileUpdatePayload,
    ApiError,
    UserProfileUpdateVariables
  >({
    mutationFn,
    onSuccess,
  });
};
